import React from 'react';
import {useElementPosition} from "use-element-position";
import {isMobile} from "../../../../util/screen";

/**
 * create the outer list for the left nav; display depends on mobile
 * @param  {} props
 * @return {React element}
 */
const ScrollingList = props => {
    if (isMobile()) {
        return (
            <ul>
                {props.children}
            </ul>
        )
    } else {
        const [ref, {offsetTop}] = useElementPosition({offsetTop: 230});

        return (
            <ul className="scrolling-list" style={{height: `calc(100vh - ${offsetTop}px`}} ref={ref}>
                {props.children}
            </ul>
        );
    }
}

export default ScrollingList;